import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ajax } from 'jquery';
import './index.css';

function replaceSpacesWithUnderscoresUsingReplaceAll(str: string): string {
    return str.replaceAll(' ', '_');
}

// 测试示例
const originalString2 = "Hello World TypeScript";
const newString2 = replaceSpacesWithUnderscoresUsingReplaceAll(originalString2);
console.log(newString2);

const Card = () => {
    const [isLoading, setLoading] = useState(false)
    const { hash } = useParams()
    const [cardData, setCardData] = useState<any>()
    const [userData, setUserData] = useState<any>()
    const [actived, setCardActived] = useState(false)

    useEffect(() => {
        const loadCardData = async (hash: string) => {
            try {
                const result = await ajax({
                    method: "GET",
                    url: `/api/v1/countryball_card/card/${hash}`,
                })
                setCardData(result)
                
                // 尝试获取用户信息，但不强制要求登录
                try {
                    const user = await ajax({
                        method: "GET",
                        url: `/api/v1/countryball_card/user`,
                    })
                    setUserData(user)
                    if (user.activedCountries.some((item: any) => item.hash === hash)) {
                        setCardActived(true)
                    }
                } catch (userErr) {
                    // 用户未登录，继续显示卡片但不显示激活状态
                    console.log('User not logged in, showing card without activation status')
                }
            } catch (err) {
                console.error('Failed to load card data:', err)
                alert('加载卡片数据失败')
            }
        }
        loadCardData(hash as string)
    }, [])

    const addBallToMine = async () => {
        // 如果用户未登录，跳转到登录页面
        if (!userData) {
            window.location.href = '/login';
            return;
        }
        
        if (!actived) {
            try {
                const result = await ajax({
                    method: "POST",
                    contentType: 'application/json',
                    url: '/api/v1/countryball_card/card/active',
                    data: JSON.stringify({
                        hash
                    })
                })
                alert('添加成功！')
                setCardActived(true);
            } catch (err: any) {
                if (err.status === 401 || err.status === 403) {
                    window.location.href = '/login';
                } else {
                    alert('添加失败！')
                }
            }
        } else {
            window.location.href = "/myballs";
        }
    }

    return (
        <div className='page-wrap card-page countryball-page'>
            {
                <div className="card-page-content">
                    {cardData &&
                        <div className='countryball-content'>
                            <div className="countryball-box" style={{ backgroundImage: 'url(' + "https://oss.usecubes.cn/countryballs/new_cards/" + replaceSpacesWithUnderscoresUsingReplaceAll(cardData.name_en) + "_front.jpg" + ')' }}></div>
                            <div className="area-box">
                                <img src="/area-pic.png" alt="" className='area-pic' />
                                <div className="desc">
                                    面积<br />
                                    {cardData.area}万平方公里
                                </div>
                            </div>
                            <div className="popular-box">
                                <img src="/popular-pic.png" alt="" className='area-pic' />
                                <div className="desc">
                                    人口<br />
                                    {cardData.population}万人
                                </div>
                            </div>
                        </div>
                    }
                    <a href="#" onClick={addBallToMine} className="common-btn add-ball">{actived ? "已拥有，查看我的国家球" : "添加至我的国家球"}</a>
                </div>
            }
        </div >
    );
}

export default Card